import { Injectable, Input } from "@angular/core";

import { BaseFpxChangeHandler, BaseFpxComponentState, BaseFpxFormHelper } from "src/app/common/utils/base-fpx.form.component";
import { FormControlStatus, FormGroup } from "@angular/forms";
import { IMaturityDetails } from "src/app/models/Deposit.model";
import { Data } from "popper.js";
import { SellOrderService } from "./sell-order.service";
import { IOpenSellOrder } from "../model/sell-order.model";
import { EMutualfundsServiceCode } from "@common/models";
import { ResultService } from "@common/services";
import { MutualFundsService } from "src/app/services/mutual-funds.service";
import { TranslateService } from "@ngx-translate/core";


export class SellOrderState extends BaseFpxComponentState {
  activeAccountNumber: string;
  disableMode: boolean;
}

@Injectable()
export class SellOrderHelper extends BaseFpxFormHelper<SellOrderState> {
 
  resultDetails: { status: string; message: string; };


  constructor(private _sellOrderService: SellOrderService,
    private _resultService: ResultService,
    private _mutualFundsService: MutualFundsService,
    private translate: TranslateService) {
    super(new SellOrderState());
    this.addChangeHandler("accountNumber", this.doAccountNumberChange);
    this.addChangeHandler("noOfUnits", this.doAmountChange);

  }
 
//  public doNoOfUnits: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
//   // if (this.balanceCheck && this.debitAccountNumber) {
//   //   this.addSyncValidatorFn(this._amountValidationService.accountBalanceCheck(this.debitAccountNumber, this.formControlName, this.errorType));
//   // }
//   if(value){
 
//  }}

doAmountChange: BaseFpxChangeHandler = (
  name: string,
  status: FormControlStatus,
  value: any,
  formGroup: FormGroup
) => {
  if (formGroup.get("noOfUnits").value == null || formGroup.get("noOfUnits").value == "" ) {
    formGroup
      .get("noOfUnits")
      .setErrors({ emptyValue: true }, { emitEvent: false });
  }
  else if( formGroup.get("noOfUnits").value == 0)
  {
    formGroup
    .get("noOfUnits")
    .setErrors({ zeroValue: true }, { emitEvent: false });
  }
};

private doAccountNumberChange : BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup)=>{
  if (value) {
      this.state.activeAccountNumber = value;
  } else {
      this.state.activeAccountNumber = '';
  }

    formGroup.controls['noOfUnits'].reset();
    formGroup.controls['termsCondition'].reset();
 

  }

fetchSellOrderDetails(requestReference, formGroup: FormGroup) {
  this._sellOrderService.fetchSellOrderDetails(requestReference).subscribe(
      (res: IOpenSellOrder)=> {
        formGroup.patchValue({
          'accountNumber': res.accountNumber,
          'noOfUnits': res.noOfUnits,
          'termsCondition': '1'
        }, {emitEvent: false});
        formGroup.disable({emitEvent: false});
        this.state.disableMode=true;
      },
      (err)=> {

      }
  );
}
  public doConfirm(context: any, success: any, failure: any) {
    context = {
      ...context,
      
   
    }

    const payload: any = {};
    payload['mfsellorder'] = context;
    this._sellOrderService.openSellOrder(payload).subscribe(
      (res) => {
          let additionalFields = {
              'referenceNumber': res.refNo?res.refNo:res.inventoryNo
              }
              let productDesc = this._mutualFundsService.getMutualFundProductDetail(context.accountNumber).accountDetails[0].productName;
                  this._resultService.setSuccess(
                    res,
                    this.translate.instant('RESULTPAGEMESSAGE.'+EMutualfundsServiceCode.SELL_ORDER).replace('productDesc',productDesc),
                    additionalFields
                  );
                  success(res);
        },
      (err) => {
        this._resultService.setFailure(
            err,
            true,
        );
        failure(err);
      }
      );
  }
  resetState(){
    this.state.disableMode=false;
  }
}